import { connect } from 'react-redux'
import get from 'lodash/get'
import { getArticleRequest } from './module'

import Article from './Article.component'

function mapStateToProps (state) {
  return {
    article: state.article.article,
    companyName: get(state.company.company, 'name')
  }
}

function mapDispatchToProps (dispatch) {
  return {
    getArticle (id) {
      dispatch(getArticleRequest(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Article)
